function findStyleElement(id) {
    return document.getElementById(id);
}
export default findStyleElement;
